export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = `${name}=${encodeURIComponent(typeof value == 'string' ? value.trim() : '')}${expires}; path=/`;
};

export const getCookie = (name) => {
  const _name = name + '=';
  const cookiesParts = document.cookie.split(';');
  for (const cookiesPart of cookiesParts) {
    if (cookiesPart.trim().indexOf(_name) === 0) {
      return decodeURIComponent(cookiesPart.trim().substring(_name.length));
    }
  }
  return null;
};

export const eraseCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
